var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_calendar_settings"},[_c('div',{staticClass:"form__container"},[_c('CreateCalendarPage',{attrs:{"isForm":true,"calendarSettings":_vm.calendarSettings,"action":_vm.saveSettings}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }